/** 排重标识 */
export const STORAGE_KEY = {
    GTM_GP: 'track_gtm_all_shop_btn_gp',
    GTM_IOS: 'track_gtm_all_shop_btn_ios',
    GTM_SECOND_GP: 'track_gtm_second_shop_btn_gp',
    GTM_SECOND_IOS: 'track_gtm_second_shop_btn_ios',
    GTM_PRE: 'track_gtm_success_pop',
    FB_SHOP: 'track_fb_all_shop_btn',
    FB_PRE: 'track_fb_pre_success',
    TT_PRE: 'track_tt_pre_success',
    TT_SHOP: 'track_tt_all_shop_btn',
    TT_PANGLE: 'track_tt_pangle_btn',
    X_GP: 'track_x_all_shop_btn_gp',
    X_IOS: 'track_x_all_shop_btn_ios',
    ZAF_IOS: 'track_zaf_all_shop_btn_ios',
    SEEDAPP_IOS: 'track_seedapp_all_shop_btn_ios',
}
